{
  "tabs": {
    "chat": "Чат",
    "reminders": "Искәртмәләр",
    "calendar": "Календарь",
    "settings": "Көйләүләр"
  },
  "common": {
    "cancel": "Бетерү",
    "save": "Саклау",
    "confirm": "Раслау",
    "delete": "Бетерү",
    "back": "Артка",
    "close": "Ябу",
    "edit": "Үзгәртү",
    "search": "Эзләү",
    "all": "Барысы",
    "loading": "Йөкләнә...",
    "error": "Хата барлыкка килде",
    "notFound": "Табылмады",
    "tryAgain": "Яңадан карагыз",
    "retry": "Кабатлау",
    "undo": "Кире кайтару",
    "pullToRefresh": "Яңарту өчен тарт",
    "justNow": "хәзер генә"
  },
  "auth": {
    "welcome": "FishMemory-га рәхим итегез",
    "tagline": "Сезнең WhatsApp искәртмә ярдәмчесе, хәзер сезнең кесәгездә.",
    "subtitle": "Сезнең WhatsApp искәртмә ярдәмчесе, хәзер сезнең кесәгездә.",
    "phoneLabel": "Сезнең WhatsApp номерыгыз",
    "phoneHint": "Без WhatsApp аша расланган код җибәрәчәкбез",
    "invalidPhone": "Дөрес телефон номеры кертегез",
    "continue": "Дәвам итү",
    "enterPhone": "WhatsApp номерыгызны кертегез",
    "phonePlaceholder": "Телефон номеры",
    "sendCode": "Код җибәрү",
    "verifyTitle": "Номерны раслатыгыз",
    "otpSentTo": "6 санлы код {{phone}} адресына WhatsApp аша җибәрелде",
    "enterFullCode": "Барлык 6 санны кертергә кирәк",
    "invalidOtp": "Дөрес булмаган код. Яңадан карагыз.",
    "otpFailed": "Код җибәрүдә хата. Яңадан карагыз.",
    "otpResent": "Код яңадан җибәрелде",
    "resendIn": "Resend in {{seconds}}s",
    "resendCode": "Кодны яңадан җибәрү",
    "enterOtp": "WhatsApp аша җибәрелгән кодны кертегез",
    "verify": "Раслау",
    "resend": "Кодны яңадан җибәрү",
    "wrongNumber": "Номер ялгышмы?",
    "backToPhone": "Телефонга кире",
    "editPhone": "Телефон номерын үзгәртү",
    "error": "Хата",
    "setupTitle": "Көйләүләрне башлыйк",
    "setupSubtitle": "Бу параметрларны соңрак Көйләүләрдә үзгәртә аласыз",
    "namePlaceholder": "Исемегез",
    "letsGo": "Көйләүне тәмамлау",
    "skipForNow": "Хәзерчә узып китү"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Хәбәр языгыз...",
    "inputPlaceholder": "Хәбәр языгыз...",
    "typing": "FishMemory яза...",
    "online": "Онлайн",
    "connecting": "Тоташу...",
    "reconnecting": "Кабат тоташу...",
    "offline": "Офлайн",
    "empty": "Сөйләшүне башлагыз",
    "emptyHint": "Искәртмәләр ясагыз, расписание карагыз яки ярдәм сорагыз.",
    "emptyAction": "Үрнәк искәртмә җибәрү",
    "actions": "Чат гамәлләре",
    "keep": "Хәбәрләрне саклау",
    "clearTitle": "Чатны чистарту",
    "clearConfirm": "Бу җайланмадан барлык хәбәрләрне бетерәсезме? Бу кире кайтмый.",
    "clear": "Чатны чистарту",
    "optionSelected": "Сайланган: {{label}}",
    "sendingSelection": "Җибәрелә...",
    "connectionLost": "Кабат тоташу..."
  },
  "reminders": {
    "title": "Минем искәртмәләр",
    "active": "Актив",
    "today": "Бүген",
    "thisWeek": "Бу атна",
    "history": "Тарих",
    "items": "элемент",
    "emptyTitle": "Искәртмәләр юк",
    "emptySubtitle": "Чаттан берсен ясагыз, ул монда күрсәтеләчәк.",
    "emptyAction": "Чатны ачу",
    "filterActive": "Актив",
    "filterToday": "Бүген",
    "filterWeek": "Бу атна",
    "filterHistory": "Тарих",
    "emptyState": "Искәртмәләр юк. Сөйләшүне башлагыз!",
    "swipeDone": "Бетте",
    "swipeSnooze": "Тәнәфес",
    "swipeDelete": "Бетерү",
    "search": "Искәртмәләрне эзләү...",
    "upcoming": "Якынлашучы",
    "completed": "Тәмамланган",
    "overdue": "Үтеп киткән",
    "tomorrow": "Иртәгә",
    "synced": "{{value}} синхронлаштырылган",
    "swipeHint": "Күбрәк гамәлләр өчен искәртмәне сөртегез",
    "noResults": "Эзләүгә туры килгән искәртмә юк",
    "noResultsHint": "Башка сүзләр белән карагыз яки эзләүне чистартыгыз",
    "deleteAllFailed": "Барлык искәртмәләрне бетерү мөмкин булмады"
  },
  "calendar": {
    "title": "Календарь",
    "today": "Бүген",
    "tomorrow": "Иртәгә",
    "completed": "бетерелгән",
    "noEvents": "Язылган вакыйгалар юк",
    "noEventsSubtitle": "Искәртмәләр һәм календарь вакыйгаларын карау өчен көнне сайлагыз.",
    "googleEvent": "Google Calendar",
    "legendActive": "Актив",
    "legendRecurring": "Кабатлана",
    "legendDone": "Бетерелгән",
    "legendGoogle": "Google",
    "previousMonth": "Элекке ай",
    "nextMonth": "Киләсе ай",
    "previousYear": "Элекке ел",
    "nextYear": "Киләсе ел",
    "goToToday": "Бүгенгә күчү",
    "all": "Барысы",
    "active": "Актив",
    "done": "Бетерелгән",
    "paused": "Туктатылган"
  },
  "settings": {
    "title": "Көйләүләр",
    "profile": "Профиль",
    "name": "Күрсәтү исеме",
    "enterName": "Исемегезне керегез",
    "language": "Тел",
    "uiLanguage": "Кушымта теле",
    "uiLanguageHelp": "Бу җайланмада кушымта интерфейсы, календарь ярлыклары һәм макет юнәлешен үзгәртә.",
    "serverLanguage": "Чат теле",
    "serverLanguageHelp": "Сервер җаваплары һәм искәртмә хәбәрләре өчен телне үзгәртә.",
    "timezone": "Вакыт поясы",
    "currentTimezone": "Хәзерге вакыт поясы",
    "timezoneHelp": "Барлык искәртмә вакытлары бу вакыт поясы буенча күрсәтелә.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Вакыт поясын саклау",
    "timezoneSaved": "Вакыт поясы яңартылды",
    "detect": "Ачыклау",
    "detectFailed": "Вакыт поясын ачыклау мөмкин булмады",
    "autoDetect": "GPS буенча автоматик ачыклау",
    "notifications": "Хәбәрләр",
    "notificationsHelp": "Кабат искәртүләр искәртмә тапшырылганнан соң кабатлау хәбәрләрен контрольдә тота. Җайланма дәрәҗәсендәге хәбәр рөхсәтләре телефон көйләүләрендә идарә ителә.",
    "pushEnabled": "Push хәбәрләре",
    "autoDoneOnFire": "Тапшыру вакытында автоматик тәмамлау",
    "autoDoneOnFireDesc": "Сүндерелгән булса, искәртмәләр сез тәмамлаганчы актив кала.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Тоташтырылган",
    "googleDisconnected": "Тоташтырылмаган",
    "googleConnectedHelp": "Яңа искәртмәләр календарьга автоматик синхронлаштырыла ала.",
    "googleDisconnectedHelp": "Искәртмәләр һәм вакыйгаларны бергә тоту өчен Google Calendar-га тоташтырыгыз.",
    "googleConnectFailed": "Google Calendar-га тоташтыру мөмкин булмады",
    "connected": "Тоташтырылган",
    "disconnected": "Тоташтырылмаган",
    "connect": "Тоташтыру",
    "disconnect": "Бүләргә",
    "autoSync": "Яңа искәртмәләрне автоматик синхронлаштыру",
    "autosync": "Яңа искәртмәләрне автоматик синхронлаштыру",
    "subscription": "Абонемент",
    "trialUsed": "Тест: {{used}}/{{total}} кулланылган",
    "trialStatus": "Тест бар",
    "activeStatus": "Актив абонемент",
    "expiredStatus": "Абонемент вакыты чыккан",
    "unsubscribedStatus": "Абонемент юк",
    "about": "Турында",
    "version": "Версия",
    "logout": "Чыгу",
    "logoutTitle": "Чыгу",
    "logoutConfirm": "Чыгарга телисезме?",
    "noName": "Исем куелмаган",
    "serverConnection": "Сервер белән тоташу",
    "serverUrl": "Сервер URL",
    "serverEdit": "Үзгәртү",
    "saveReconnect": "Саклау һәм кабат тоташу",
    "resetDefault": "Төпкә кайтару",
    "invalidServerUrlTitle": "Дөрес булмаган сервер URL",
    "invalidServerUrlMessage": "Дөрес http яки https сервер URL кертегез, мәсәлән https://example.com",
    "uiLanguageChangeFailed": "Кушымта телен үзгәртү мөмкин булмады. Яңадан карагыз.",
    "serverLanguageChangeFailed": "Чат телен үзгәртү мөмкин булмады. Яңадан карагыз.",
    "timezoneChangeFailed": "Вакыт поясын үзгәртү мөмкин булмады. Яңадан карагыз.",
    "autoSyncChangeFailed": "Автоматик синхронлаштыруны яңарту мөмкин булмады. Яңадан карагыз.",
    "nameChangeFailed": "Күрсәтү исемен яңарту мөмкин булмады. Яңадан карагыз.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Искәртмә детальләре",
    "editTime": "Вакытны үзгәртү",
    "rename": "Исемен үзгәртү",
    "snooze": "Тәнәфес",
    "snooze15": "15 минутка тәнәфес",
    "pause": "Туктату",
    "pauseReminder": "Искәртмәне туктату",
    "resume": "Дәвам итү",
    "resumeReminder": "Искәртмәне дәвам итү",
    "skip": "Киләсе очрашуны узу",
    "skipOccurrence": "Бу очрашуны узу",
    "syncGoogle": "Google белән синхронлаштыру",
    "delete": "Бетерү",
    "deleteTitle": "Искәртмәне бетерү",
    "deleteConfirm": "Бу искәртмә даими рәвештә бетереләчәк.",
    "deleteRecurringTitle": "Кабатланучы искәртмәне бетерү",
    "deleteRecurringMessage": "Бу очрашуны узарга телисезме яки бөтен серияне бетерергә?",
    "deleteThisOccurrence": "Бу очрашуны узу",
    "deleteEntireSeries": "Бөтен серияне бетерү",
    "done": "Бетте",
    "markDone": "Бетерелгән дип билгеләү",
    "undo": "Кире кайтару",
    "undoPrompt": "Яңадан актив итәргә кирәкме? Хәзер кире кайтарыгыз.",
    "recurring": "Кабатлана",
    "nextRun": "Киләсе тапкыр",
    "oneTime": "Бер тапкыр",
    "pending": "Көтүдә",
    "sent": "Җибәрелгән",
    "paused": "Туктатылган",
    "active": "Актив",
    "snoozed": "Тәнәфескә куелган",
    "localTime": "Сезнең җирле вакытта күрсәтелә",
    "recurrence": "Кабатлану",
    "created": "Яратылган",
    "tags": "Тэглар",
    "fireCount": "Тапкырлар саны",
    "actions": "Гамәлләр",
    "none": "Юк",
    "snoozeFailed": "Искәртмәне тәнәфескә кую мөмкин булмады",
    "pauseFailed": "Искәртмәне туктату мөмкин булмады",
    "resumeFailed": "Искәртмәне дәвам итү мөмкин булмады",
    "skipFailed": "Искәртмәне узу мөмкин булмады",
    "doneFailed": "Искәртмәне бетерелгән дип билгеләү мөмкин булмады",
    "undoFailed": "Искәртмә статусын кире кайтару мөмкин булмады",
    "deleteFailed": "Искәртмәне бетерү мөмкин булмады",
    "rescheduleTitle": "Кабат билгеләргә?",
    "rescheduleMsg": "Бу искәртмә вакытыннан узган. Кабат билгеләргә телисезме?",
    "reschedule15": "15 минуттан соң",
    "reschedule60": "1 сәгатьтән соң",
    "keepOverdue": "Калганча саклау"
  },
  "onboarding": {
    "slide1Title": "FishMemory-га рәхим итегез",
    "slide1Sub": "Сезнең шәхси искәртмә ярдәмчесе — WhatsApp белән эшли һәм кесәгез өчен ясалган.",
    "slide2Title": "Гади сөйләшү",
    "slide2Sub": "Искәртмәләрне уйлаганча языгыз: «Иртәгә 3тә әнигә шалтыратуны искәрт» — калганын без эшлибез.",
    "slide3Title": "Бернәрсә дә онытмагыз",
    "slide3Sub": "Вакытында хәбәрләр алыгыз, тэглар белән оештырыгыз һәм мөһимнәрне күзәтеп барыгыз.",
    "getStarted": "Башлау",
    "next": "Алга",
    "firstReminderTitle": "Беренче искәртмәгезне ясагыз!",
    "firstReminderHint": "Мәсәлән, язып карагыз:",
    "firstReminderExample": "Иртәгә 9да су эчүне искәрт",
    "gotIt": "Аңладым!",
    "notifRationaleTitle": "Вакытында булыгыз",
    "notifRationaleBody": "FishMemory вакытында искәртү өчен хәбәрләр кирәк. Сез ясаган искәртмәләр өчен генә хәбәрләр киләчәк.",
    "notifRationaleAllow": "Хәбәрләрне рөхсәт итү",
    "notifRationaleLater": "Бәлки соңрак",
    "swipeHint": "Тиз гамәлләр өчен уңга сөртегез →",
    "calendarDragHint": "Зуррак итү өчен тартыгыз ↕"
  }
}
